export default require('./FinishCard').default
